import { render, staticRenderFns } from "./PlainEditor.vue?vue&type=template&id=7a380188&scoped=true"
import script from "./PlainEditor.vue?vue&type=script&lang=js"
export * from "./PlainEditor.vue?vue&type=script&lang=js"
import style0 from "./PlainEditor.vue?vue&type=style&index=0&id=7a380188&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a380188",
  null
  
)

export default component.exports